import { render, staticRenderFns } from "./FilterCheckboxes.vue?vue&type=template&id=56d52e6b&"
import script from "./FilterCheckboxes.vue?vue&type=script&lang=js&"
export * from "./FilterCheckboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports